import { IconeMensagemAgendada, IconeRetorno, IconeTarefa } from '../../componentes/icones'
import { Modal } from '../../componentes/ui'

/**
 * Qual dos três agendamentos.
 *
 * A barra tinha um ícone para cada um — mensagem, tarefa e retorno — e os três
 * são relógios parecidos, lado a lado, dizendo "agendar" no rótulo. Ninguém
 * decora qual é qual, e a diferença entre eles é justamente a parte perigosa:
 * **uma sai para o cliente e as outras duas não**.
 *
 * Três ícones não conseguem explicar isso; uma janela consegue. O que se
 * ganha em cliques se perde em dúvida, e a dúvida aqui manda mensagem para
 * cliente sem querer.
 */

interface Opcao {
  chave: 'mensagem' | 'tarefa' | 'retorno'
  Icone: typeof IconeMensagemAgendada
  titulo: string
  descricao: string
  /** Destaca o que chega ao cliente, que é o único com consequência externa. */
  vaiParaOCliente?: boolean
}

const OPCOES: Opcao[] = [
  {
    chave: 'mensagem',
    Icone: IconeMensagemAgendada,
    titulo: 'Mensagem para o cliente',
    descricao: 'Sai pelo WhatsApp na hora marcada, assinada com o seu nome.',
    vaiParaOCliente: true,
  },
  {
    chave: 'tarefa',
    Icone: IconeTarefa,
    titulo: 'Tarefa no calendário',
    descricao: 'Lembrete para você. O cliente não recebe nada e não vê.',
  },
  {
    chave: 'retorno',
    Icone: IconeRetorno,
    titulo: 'Retorno deste atendimento',
    descricao:
      'Na hora marcada a conversa volta para você, reaberta se estiver encerrada. Nada é enviado.',
  },
]

export function EscolherAgendamento({
  aberto,
  aoFechar,
  aoEscolher,
}: {
  aberto: boolean
  aoFechar: () => void
  aoEscolher: (opcao: Opcao['chave']) => void
}) {
  return (
    <Modal aberto={aberto} titulo="O que você quer agendar?" aoFechar={aoFechar}>
      <ul className="space-y-2">
        {OPCOES.map((opcao) => (
          <li key={opcao.chave}>
            <button
              type="button"
              onClick={() => aoEscolher(opcao.chave)}
              className="flex w-full items-start gap-3 rounded-lg ring-1 ring-tinta-200 px-3 py-3 text-left transition hover:ring-marca hover:bg-marca/5"
            >
              <opcao.Icone className="mt-0.5 h-5 w-5 shrink-0 text-tinta-600" />
              <span className="min-w-0 flex-1">
                <span className="flex items-center gap-2">
                  <span className="text-sm font-medium text-tinta-900">{opcao.titulo}</span>
                  {/*
                    O aviso fica no que sai, não no que fica. Marcar as duas
                    internas com "não envia" faria três selos onde só um caso
                    tem consequência para fora.
                  */}
                  {opcao.vaiParaOCliente ? (
                    <span className="shrink-0 rounded bg-amber-100 px-1.5 py-0.5 text-[11px] font-medium text-amber-800">
                      chega ao cliente
                    </span>
                  ) : null}
                </span>
                <span className="mt-0.5 block text-xs text-tinta-500">{opcao.descricao}</span>
              </span>
            </button>
          </li>
        ))}
      </ul>
    </Modal>
  )
}
